import { Dialog } from "@progress/kendo-react-dialogs";
import {
	GridCellProps,
	GridColumnProps,
	GridItemChangeEvent,
} from "@progress/kendo-react-grid";

import { t } from "i18next";
import React, { FC, useEffect, useRef, useState } from "react";
import CustomButton from "ui/Button";
import CustomGrid from "ui/grid/CustomGrid";
import { CustomGridCommandCell } from "ui/grid/GridCommandCell";
import { CLASSNAME, COLOR, ICON_NAMES } from "utils/constant";
import { Comment } from ".";
import style from "./style.module.css";
import Info from "ui/Info";
import {
	deleteLandingNoteLineComment,
	getLandingNoteLineComments,
	SaveLandingNoteLineComment,
} from "api/landingNote";
import { useInfoStore } from "store/error";
import { TextEditCell } from "ui/grid/TextEditCell";

interface LineComment extends Comment {
	inEdit?: boolean;
}

const NoteModal: FC<{
	showModal: boolean;
	setShowModal: () => void;
	gridProps: GridCellProps;
}> = ({ showModal, setShowModal, gridProps }) => {
	const [lineComments, setLineComments] = useState<LineComment[]>([]);
	const [showDeleteLine, setShowDeleteLine] = useState(false);
	const deletingLineRef = useRef<LineComment>();
	const { setError } = useInfoStore();

	const dataItem = gridProps.dataItem;

	useEffect(() => {
		getData();
	}, []);

	const handleOnChangeItem = (e: GridItemChangeEvent) => {
		const item = e.dataItem;
		addNewLine(item.id, e.value);
	};

	const getData = () => {
		getLandingNoteLineComments(dataItem.id)
			.then((response) => {
				setLineComments(
					response.data.map((line) => ({
						...line,
						inEdit: true,
						editable: true,
					})),
				);
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const addNewLine = (id: number = 0, description: string = "") => {
		SaveLandingNoteLineComment({
			id,
			noteLineId: dataItem.id,
			description,
		})
			.then((response) => {
				getData();
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const handleDeleteItem = (data: GridCellProps) => {
		deletingLineRef.current = data.dataItem;
		setShowDeleteLine(true);
	};

	const deleteLine = () => {
		if (!deletingLineRef.current) return;
		deleteLandingNoteLineComment(deletingLineRef.current.id)
			.then((response) => {
				//console.log("line deleted");
				getData();
				setShowDeleteLine(!showDeleteLine);
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const gridItems: GridColumnProps[] = [
		{
			field: "lineNumber",
			title: "Lnr",
			width: "40px",
			className: ` no-border`,
			editable: false,
		},
		{
			field: "description",
			title: "Notat",
			editable: true,

			className: ` no-border`,
			editor: "text",
			cells: {
				data: (props) => (
					<TextEditCell
						{...props}
						field="description"
						// style={{ display: "flex", justifyContent: "flex-end" }}
						// onclick={handleDeleteItem}
					/>
				),
			},
		},
		{
			field: "",
			title: "",
			cells: {
				data: (props) => (
					<CustomGridCommandCell
						{...props}
						style={{ display: "flex", justifyContent: "flex-end" }}
						onclick={handleDeleteItem}
						iconName={ICON_NAMES.Delete}
					/>
				),
			},

			width: "60px",
		},
	];
	//console.log("lineComments", lineComments);
	return (
		<>
			{showModal && (
				<Dialog
					title={`Note line  comments `}
					onClose={() => setShowModal()}
					className={style.ModalContainer}
					height={"70%"}
					contentStyle={{
						height: "70%",
					}}
				>
					<div>
						<CustomGrid
							gridColumns={gridItems}
							data={lineComments}
							dataItemKey="id"
							// edit={{ 1: true }}
							editable={{
								mode: "inline",
							}}
							className={CLASSNAME.TableNumeric + " " + CLASSNAME.HideOverFlow}
							onItemChange={handleOnChangeItem}
						/>
						<div
							style={{
								marginTop: "20px",
								display: "flex",
								justifyContent: "space-between",
							}}
						>
							<CustomButton
								label={t("NewLine") + " +"}
								onClick={addNewLine}
								bgColor={COLOR.Green}
								color="white"
							/>
						</div>
						<Info
							close={() => setShowDeleteLine(!showDeleteLine)}
							title={t("DeleteLine")}
							show={showDeleteLine}
							description={t("DeleteLineConfirmation")}
							actions={[
								{
									text: t("Cancel"),
									btn: () => setShowDeleteLine(!showDeleteLine),
								},
								{
									text: t("Yes"),
									btn: deleteLine,
									bgColor: "red",
									textColor: "white",
								},
							]}
						/>
					</div>
				</Dialog>
			)}
		</>
	);
};

export default NoteModal;
